import { TrendingUp, TrendingDown, Zap } from "lucide-react";

const RANK = ["🥇", "🥈", "🥉"];

export default function PsiMoversBoard({ data, title = "Top 3 PSI Movers", live = false, compact = false, testid = "psi-movers" }) {
  const top3 = data?.top3 || [];
  return (
    <div className={`border ${live ? "border-amber-400/50 bg-amber-400/[0.04]" : "border-pb-border bg-zinc-950"} p-3`} data-testid={testid}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest text-amber-300">
          <Zap className={`w-4 h-4 ${live ? "animate-pulse" : ""}`} /> {title}
        </div>
        <span className="text-[9px] uppercase tracking-widest text-zinc-600" data-testid={`${testid}-meta`}>
          {data?.final ? `Final · ${(data.days || []).length || 1} day${(data.days || []).length === 1 ? "" : "s"}` : live ? "This tournament · live" : data?.day || ""}
        </span>
      </div>
      {top3.length === 0 ? (
        <div className="text-zinc-600 text-xs py-3 text-center" data-testid={`${testid}-empty`}>
          {live ? "No PSI movement yet — approve the first score and the board lights up." : "No PSI movement recorded."}
        </div>
      ) : (
        <div className={`grid gap-2 ${compact ? "" : "sm:grid-cols-3"}`}>
          {top3.map((r, i) => {
            const up = r.delta >= 0;
            return (
              <div key={r.user_id} data-testid={`${testid}-rank-${i + 1}`}
                className={`border p-2.5 flex items-center gap-2.5 ${i === 0 ? "border-amber-400/70 bg-amber-400/10" : "border-pb-border bg-pb-elevated/40"}`}>
                <span className="text-xl leading-none">{RANK[i]}</span>
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-bold truncate" data-testid={`${testid}-name-${i + 1}`}>{r.name}</div>
                  <div className="text-[10px] text-zinc-500 font-mono">{r.start_psi} → <span className="text-white">{r.current_psi}</span> · {r.matches} match{r.matches === 1 ? "" : "es"}</div>
                </div>
                <div className={`flex items-center gap-1 font-mono font-black text-lg ${up ? "text-emerald-300" : "text-pb-red"}`} data-testid={`${testid}-delta-${i + 1}`}>
                  {up ? <TrendingUp className="w-4 h-4" /> : <TrendingDown className="w-4 h-4" />}{up ? "+" : ""}{r.delta.toFixed(2)}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
